import { type DropZone } from '~/components/PrivateDropzone/types';
import { type BoardsSelectOption } from '~/types/BoardSearch';

export type ResolvePrivateUploadDestinationParams = {
  currentBoardId: string | null;
  currentBoardTitle: string | undefined;
  dropZone: DropZone | null;
  selectedBoard: BoardsSelectOption | null;
};

/**
 * PreUploadModal uses `null` for "All assets & files". Only a direct drop on the
 * current board (`dropZone === 'upload'`) should fall back to the URL board —
 * otherwise a workspace-root choice would be overwritten by the page the user
 * happens to be on.
 */
export const resolvePrivateUploadDestination = ({
  currentBoardId,
  currentBoardTitle,
  dropZone,
  selectedBoard,
}: ResolvePrivateUploadDestinationParams): BoardsSelectOption | undefined => {
  if (selectedBoard) {
    return selectedBoard;
  }

  if (dropZone === 'upload' && currentBoardId && currentBoardTitle) {
    return { id: currentBoardId, title: currentBoardTitle };
  }

  return undefined;
};
